import {
  input,
  Inject,
  computed,
  Optional,
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';

import { SVG_SPRITE_URL } from './svg-icon.tokens';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'svg[icon]',
  template: '<svg:use [attr.href]="href()"></svg:use>',
  styleUrl: './svg-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'svg-icon',
  },
})
export class SvgIconComponent {
  icon = input.required<string>();

  constructor(@Optional() @Inject(SVG_SPRITE_URL) public spriteUrl: string | null) {}

  href = computed(() => `${this.spriteUrl}#${this.icon()}`);
}
